import React from 'react';
import { faToolbox } from '@fortawesome/free-solid-svg-icons';
import RouteSeo from '../components/RouteSeo';
import ToolCard from '../components/ToolCard';
import ToolContent from '../components/ToolContent';
import PageShell from '../components/layout/PageShell';
import PageHeader from '../components/layout/PageHeader';
import { TOOLS, TOOLS_ROUTE } from '../content/tools';
import './ToolsIndex.css';

/**
 * The tools index. Every tool page links here and here, and the prerender step
 * emits the same list as static HTML, so a crawler that never runs JavaScript
 * still finds every tool one hop from the homepage.
 */
const ToolsIndex: React.FC = () => (
  <>
    <RouteSeo route={TOOLS_ROUTE} />
    <PageShell width="wide">
      <PageHeader
        align="center"
        icon={faToolbox}
        title={TOOLS_ROUTE.h1}
        subtitle={TOOLS_ROUTE.tagline}
      />
      <ul className="tools-index tool-grid">
        {TOOLS.map((tool) => (
          <li key={tool.slug}>
            <ToolCard route={tool} />
          </li>
        ))}
      </ul>
      <div className="tools-index__prose">
        <ToolContent route={TOOLS_ROUTE} hideRelated />
      </div>
    </PageShell>
  </>
);

export default ToolsIndex;
